import { EventEmitter, inject,Injectable } from '@angular/core';
import { DpFieldDate, DpFormButton, DpFormButtonType, DpFormRow, DpModalForm, DpModalFormService, DpModalFormSize, DpModalService } from '@docpath/webcomponents';

import { Constants } from '../../../../constants/constants';
import { SinclairCard } from '../model/sinclair-card-type';


@Injectable({
    providedIn: 'root'
})
export class SinclairCardsFormService {

    readonly i18nPrefix = 'cards.form';

    private readonly modalService = inject(DpModalService);
    private readonly modalFormService = inject(DpModalFormService);

    initModalForm(): DpModalForm {

        return new DpModalForm({
            header: `${this.i18nPrefix}.header.title`,
            rows: [
                new DpFormRow([
                    new DpFieldDate({ name: Constants.CARD_FILTERS_CUSTOM_HOURS_FROM, column: 9, labelColumn: 3, required: true, hasTime: true, format: 'YYYY-MM-DD HH:mm' })
                ]),
                new DpFormRow([
                    new DpFieldDate({ name: Constants.CARD_FILTERS_CUSTOM_HOURS_TO, column: 9, labelColumn: 3, required: true, hasTime: true, format: 'YYYY-MM-DD HH:mm' })
                ])
            ],
            size: DpModalFormSize.Default,
            i18nPrefix: this.i18nPrefix,
            buttons: this.getFormButtons(),
            allowUnchangedSubmit: true // Flag activo para permitir el envío del formulario aunque no se haya modificado ningún campo ya que los calendarios están inicializados de antemano
        });

    }

    openCreationCustomDateSearchForm(card: SinclairCard, filterChanged: EventEmitter<void>, tooltip: string): void {

        const form = this.initModalForm();

        form.submit = (value, activeModal) => {
            const validate = this.validateDates(value.from, value.to);
            if (validate !== '') {
                this.modalService.openError(validate);

                return;
            }

            card.tooltip = tooltip;
            card.title = `${this.formatDate(value.from)} - ${this.formatDate(value.to)}`;
            card.filters.forEach(filter => {
                if (filter.title === 'statistics.cards.filters.number-hours.custom.label') {
                    filter.active = true;
                } else {
                    filter.active = false;
                }
            });
            activeModal.close();
            filterChanged.emit();
        };

        form.formGroupAdded.subscribe(() => {
            const dateTimeFrom = new Date();
            const dateTimeTo = new Date(dateTimeFrom.getTime());
            dateTimeTo.setMinutes(dateTimeFrom.getMinutes() + 1);
            form.setValue({
                [Constants.CARD_FILTERS_CUSTOM_HOURS_FROM]: dateTimeFrom,
                [Constants.CARD_FILTERS_CUSTOM_HOURS_TO]: dateTimeTo
            });
        });

        this.modalFormService.open(form);

    }

    private getFormButtons(): DpFormButton[] {
        return [
            new DpFormButton({ type: DpFormButtonType.Cancel, enabled: true }),
            new DpFormButton({ type: DpFormButtonType.Submit, label: 'cards.form.button-search' })
        ];
    }

    private formatDate(date: Date): string {

        if (date) {
            if (!Number.isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = `${date.getMonth() + 1}`.padStart(2, '0');
                const day = `${date.getDate()}`.padStart(2, '0');

                const hours = `${date.getHours()}`.padStart(2, '0');
                const minutes = `${date.getMinutes()}`.padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:00`;
            }

            return date.toString();
        }

        return '';
    }

    private validateDates(from: Date, to: Date): string {

        let validate = '';

        if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
            validate = `${this.i18nPrefix}.invalid-date`;
        } else if (from.getTime() >= to.getTime()) {
            validate = `${this.i18nPrefix}.invalid-range`;
        }

        return validate;
    }
}